module.exports = __webpack_public_path__ + "static/img/logo_wechatpay.f82fb08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_wechatpay.png
// module id = PWCm
// module chunks = 1